// extracted by mini-css-extract-plugin
export var currencyInput = "_l2-1";
export var currencySymbol = "_l2-0";